mutation UpdateUserUploadedMaterial($input: UpdateUserUploadedMaterialInput!) {
  updateUserUploadedMaterial(input: $input) {
    id
    url
    previewFile {
      id
      url
      name
    }
    displayName
    type
    createdAt
  }
}
